<template>
  <div class="wrapper">
    <aside>
      <!-- <ul>
        <li v-for="d in pdfList" :key="d">
          <a href="#" @click="loadDocument(d)">{{ d }}</a>
        </li>
      </ul> -->

      <FilesList :files="files" @file-selected="loadDocument" />
    </aside>

    <main class="viewer">
      <div
        v-show="loadedPages != numPages"
        class="viewer__progress-bar"
        :style="{ width: (loadedPages / numPages) * 100 + '%' }"
      ></div>
      <div class="viewer__toolbar">
        <!-- <button @click="zoomIn">+</button>
        <button @click="zoomOut">-</button> -->
        <button @click="openPdf" v-show="pdfPath">Otevřít PDF</button>
      </div>
      <div class="viewer__content">
        <div class="viewer__content__message" v-if="numPages === 0">
          V levém sloupci vyberte dokument k zobrazení.
        </div>
        <pdf
          v-for="i in numPages"
          :key="i"
          :src="src"
          :page="i"
          :style="viewerContentStyles"
          @page-loaded="onLoadedPage(i)"
          @error="error"
        ></pdf>
      </div>
    </main>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import FilesList from "./components/FilesList.vue";
import { API_URL } from "@/constants";

// var loadingTask = pdf.createLoadingTask(
//   "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf"
// );

export default {
  name: "app",
  components: {
    pdf,
    FilesList,
  },
  data() {
    return {
      src: null,
      pdfPath: null,
      // src: loadingTask,
      // src:
      //   "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf",
      scale: 1.0,
      numPages: 0,
      loadedPages: 0,
      // pdfList: [
      //   "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf",
      //   "https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/freeculture.pdf",
      //   "https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/annotation-link-text-popup.pdf",
      //   "https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/calrgb.pdf",
      // ],
      files: [],
    };
  },
  mounted() {
    if (this.src) {
      this.src.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    }
    fetch(`${API_URL}/results`)
      .then((response) => response.json())
      .then((data) => {
        this.files = data;
      });
  },
  methods: {
    onLoadedPage(i) {
      this.loadedPages = i;
    },

    zoomIn() {
      this.scale = this.scale + 0.12;
    },
    zoomOut() {
      this.scale = this.scale - 0.12;
      if (this.scale < 0.12) this.scale = 0.12;
    },
    loadDocument(document) {
      this.src = pdf.createLoadingTask(document);
      this.pdfPath = document;

      this.src.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    },
    openPdf() {
      window.open(this.pdfPath, "_blank").focus();
    },
    error: function(err) {
      window.console.log(err);
    },
  },
  computed: {
    viewerContentStyles: function() {
      let width = 90;
      return `display: block; width: ${width *
        this.scale}%; margin: 1rem auto; background-color: #fff;`;
      // return `display: block; width: 90%; transform: scale(${this.scale}); margin: 1rem auto;`;
    },
  },
};
</script>

<style>
body {
  font-size: 1rem;
  font-family: "Open Sans", sans-serif;
  color: #1a1919;
  background-color: #fffffe;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  font-smoothing: antialiased;
  font-weight: 400;
  padding: 0;
  margin: 0;

  box-sizing: border-box;
}
</style>
<style scoped>
.wrapper {
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
}

aside {
  overflow-x: hidden;
  overflow-y: auto;
  width: 40%;
  max-width: 400px;
  word-wrap: break-word;
  font-size: 0.75rem;
}

.viewer {
  background-color: #555;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.viewer__progress-bar {
  background-color: #3a87df;
  height: 3px;
  z-index: 999;
  position: relative;
  box-shadow: 0 0 10px #29d, 0 0 5px #29d;
}
.viewer__toolbar {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 999;
  text-align: center;
}
.viewer__content {
  overflow-y: auto;
  overflow-x: auto;
  height: 100%;
  width: 100%;

  position: absolute;
  top: 0;
  left: 0;
}
.viewer__content__message {
  font-weight: bold;
  color: #eee;
  text-align: center;
  font-size: 0.8rem;

  width: 100%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

button {
  cursor: pointer;
}
</style>
